module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "longanStart", function() { return longanStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "longanDispatch", function() { return longanDispatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "longanDispatchError", function() { return longanDispatchError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "longanUpdateConfig", function() { return longanUpdateConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dispatchWithoutRegister", function() { return dispatchWithoutRegister; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "longanAddSchema", function() { return longanAddSchema; });
/* harmony import */ var _ErrorBoundary_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ErrorBoundary", function() { return _ErrorBoundary_index__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _register__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _dispatch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/* harmony import */ var _updateConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8);
/* harmony import */ var _addSchema__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9);






var longan = {
  ErrorBoundary: _ErrorBoundary_index__WEBPACK_IMPORTED_MODULE_0__["default"],
  start: _register__WEBPACK_IMPORTED_MODULE_1__["default"],
  dispatch: _dispatch__WEBPACK_IMPORTED_MODULE_2__["dispatchEvent"],
  dispatchError: _dispatch__WEBPACK_IMPORTED_MODULE_2__["dispatchError"],
  updateConfig: _updateConfig__WEBPACK_IMPORTED_MODULE_3__["default"],
  dispatchWithoutRegister: _dispatch__WEBPACK_IMPORTED_MODULE_2__["dispatchWithoutRegister"],
  addSchema: _addSchema__WEBPACK_IMPORTED_MODULE_4__["default"]
};

// module.exports = ErrorBoundary;


var longanStart = _register__WEBPACK_IMPORTED_MODULE_1__["default"];
var longanDispatch = _dispatch__WEBPACK_IMPORTED_MODULE_2__["dispatchEvent"];
var longanDispatchError = _dispatch__WEBPACK_IMPORTED_MODULE_2__["dispatchError"];
var longanUpdateConfig = _updateConfig__WEBPACK_IMPORTED_MODULE_3__["default"];
var dispatchWithoutRegister = _dispatch__WEBPACK_IMPORTED_MODULE_2__["dispatchWithoutRegister"];
var longanAddSchema = _addSchema__WEBPACK_IMPORTED_MODULE_4__["default"];

/* harmony default export */ __webpack_exports__["default"] = (longan);

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _register__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ErrorBoundary = function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    _classCallCheck(this, ErrorBoundary);

    var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

    _this.state = {
      hasError: false,
      errorMessage: '',
      errorInfo: ''
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, info) {
      // 将错误日志上报给服务器
      this.setState({
        hasError: true,
        errorMessage: error,
        errorInfo: info
      });
      this.logErrorToMyService(error, info);
    }
  }, {
    key: 'logErrorToMyService',
    value: function logErrorToMyService(error, info) {
      var errorAutoReload = this.props.errorAutoReload;

      var config = window.LONGAN_CONFIG;
      var payload = _extends({}, config, {
        error_message: error,
        error_script_url: '',
        error_line: '',
        error_column: '',
        error_content: '',
        error_type: _constants_js__WEBPACK_IMPORTED_MODULE_3__["ERROR_TYPE_OPTIONS"][Object(_utils__WEBPACK_IMPORTED_MODULE_2__["getErrorType"])(error.toString())]
      });
      var errorKey = '' + error.toString();
      if (!window._LONGAN_CACHE_ERROR_[errorKey] || new Date().valueOf() - window._LONGAN_CACHE_ERROR_[errorKey] > 600000) {
        Object(_register__WEBPACK_IMPORTED_MODULE_1__["sendRequest"])(payload, 'error');
        window._LONGAN_CACHE_ERROR_[errorKey] = new Date().valueOf();
      }
      // sendRequest(payload, 'error');
      if (errorAutoReload) {
        location.reload();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var customErrUI = this.props.customErrUI;

      if (this.state.hasError) {
        // 你可以自定义降级后的 UI 并渲染
        if (customErrUI) {
          return customErrUI;
        }
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'div',
          null,
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'div',
            { style: { color: '#666', fontSize: 20, marginBottom: 10 } },
            '\u9875\u9762\u51FA\u73B0\u9519\u8BEF\uFF0C\u4EE5\u4E0B\u662F\u9519\u8BEF\u4FE1\u606F\uFF0C\u611F\u8C22\u60A8\u7684\u53CD\u9988\u3002'
          ),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'h3',
            null,
            this.state.errorMessage.toString()
          ),
          react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'pre',
            null,
            this.state.errorInfo && this.state.errorInfo.componentStack
          )
        );
      }
      return this.props.children;
    }
  }], [{
    key: 'getDerivedStateFromError',
    value: function getDerivedStateFromError(error) {
      // 更新 state 使下一次渲染能够显示降级后的 UI
      return { hasError: true };
    }
  }]);

  return ErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (ErrorBoundary);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendRequest", function() { return sendRequest; });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _ListenHistroy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _ListenHistroy__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ListenHistroy__WEBPACK_IMPORTED_MODULE_2__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






/* harmony default export */ __webpack_exports__["default"] = (function (config) {
  if (!validateParams(config)) {
    console.error('请配置longan参数');
    window.LONGAN_CONFIG = null;
    return false;
  }

  // if (config.env.online !== window.location.host && config.env.uat !== window.location.host && config.env.develop !== window.location.host) {
  //   console.warn('当前环境与配置不符，不上报pv信息');
  //   window.LONGAN_CONFIG = null;
  //   return false;
  // }
  var _config$env = config.env,
      online = _config$env.online,
      uat = _config$env.uat,
      develop = _config$env.develop;
  // env配置全部变成数组

  if (!Array.isArray(online)) {
    config.env.online = [online || ''];
  }
  if (!Array.isArray(uat)) {
    config.env.uat = [uat || ''];
  }
  if (!Array.isArray(develop)) {
    config.env.develop = [develop || ''];
  }

  if (![].concat(_toConsumableArray(config.env.online), _toConsumableArray(config.env.uat), _toConsumableArray(config.env.develop)).includes(window.location.host)) {
    console.warn('当前环境与配置不符，不上报pv信息');
    window.LONGAN_CONFIG = null;
    return false;
  }

  // 添加unsfafe meta标签
  Object(_utils__WEBPACK_IMPORTED_MODULE_1__["whitherAddMeta"])();
  // window.LONGAN_CONFIG = config;
  window.LONGAN_CONFIG = _extends({}, config, window.LONGAN_CONFIG);
  window._LONGAN_CACHE_ERROR_ = {}; // 初始化error_cahce 
  // uploadPv(config);
  uploadPv(window.LONGAN_CONFIG);
  listenGlobalError(config);
  // 监听全局的点击事件
  listenTriggerEvent(config);
});

var validateParams = function validateParams(config) {
  var fields = ['project_name', 'env'];
  var result = fields.find(function (field) {
    return !config[field];
  });
  return !result;
};

// 监听history对象变化 + 监听hash变化 + onload事件，发送pv
var uploadPv = function uploadPv(config) {
  window.onunload = function () {
    // 上报PV
    sendRequest(config, 'basic');
    // 上报性能信息
    var _window$performance$t = window.performance.timing,
        domainLookupEnd = _window$performance$t.domainLookupEnd,
        domainLookupStart = _window$performance$t.domainLookupStart,
        connectEnd = _window$performance$t.connectEnd,
        connectStart = _window$performance$t.connectStart,
        secureConnectionStart = _window$performance$t.secureConnectionStart,
        responseStart = _window$performance$t.responseStart,
        requestStart = _window$performance$t.requestStart,
        responseEnd = _window$performance$t.responseEnd,
        domInteractive = _window$performance$t.domInteractive,
        loadEventStart = _window$performance$t.loadEventStart,
        domContentLoadedEventEnd = _window$performance$t.domContentLoadedEventEnd,
        fetchStart = _window$performance$t.fetchStart;

    var performanceParams = {
      dns: domainLookupEnd - domainLookupStart,
      tcp: connectEnd - connectStart,
      ssl: connectEnd - secureConnectionStart,
      ttfb: responseStart - requestStart,
      trans: responseEnd - responseStart,
      dom: domInteractive - responseEnd,
      res: loadEventStart - domContentLoadedEventEnd,
      firstbyte: responseStart - domainLookupStart,
      fpt: responseEnd - fetchStart,
      tti: domInteractive - fetchStart,
      ready: domContentLoadedEventEnd - fetchStart,
      load: loadEventStart - fetchStart
    };
    sendRequest(_extends({}, config, performanceParams), 'performance');
  };
  window.addHistoryListener('history', function () {
    // 上报PV
    sendRequest(config, 'basic');
  });
  window.onhashchange = function () {
    // 上报PV
    sendRequest(config, 'basic');
  };
};

// 监听全局错误，并上报
var listenGlobalError = function listenGlobalError(config) {
  window.onerror = function (errorMessage, scriptURI, lineNo, columnNo, error) {
    console.log(errorMessage, 'onerror');
    var error_content = error ? error['stack'] : '-1';
    var errorParams = {
      error_content: error_content,
      error_message: errorMessage || '-1',
      error_script_url: scriptURI || '-1',
      error_line: lineNo || '-1',
      error_column: columnNo || '-1',
      error_level: '2', // onerror收集的错误默认是p2级别，为0时触发北斗报警
      error_type: _constants_js__WEBPACK_IMPORTED_MODULE_0__["ERROR_TYPE_OPTIONS"][Object(_utils__WEBPACK_IMPORTED_MODULE_1__["getErrorType"])(errorMessage.toString())] || 1
    };
    var filter_error_msg = window.LONGAN_CONFIG.filter_error_msg;

    if (filter_error_msg && Array.isArray(filter_error_msg)) {
      var filterResult = filter_error_msg.filter(function (item) {
        return errorMessage.includes(item);
      });
      if (filterResult && filterResult.length) {
        return false;
      }
    }
    // 过滤error，对error信息进行sdk级的缓存，如果击中了缓存并且在5s以内，则不上报
    var errorKey = '' + errorMessage.toString();
    if (!window._LONGAN_CACHE_ERROR_[errorKey] || new Date().valueOf() - window._LONGAN_CACHE_ERROR_[errorKey] > 600000) {
      sendRequest(_extends({}, errorParams, config), 'error');
      window._LONGAN_CACHE_ERROR_[errorKey] = new Date().valueOf();
    }
  };
};

// 监听全局事件埋点
var listenTriggerEvent = function listenTriggerEvent(config) {
  document.addEventListener('click', function (e) {
    if (e.target.id && e.target.id.startsWith(_constants_js__WEBPACK_IMPORTED_MODULE_0__["EVENT_PREFIX"])) {
      var event_name = e.target.id.split(_constants_js__WEBPACK_IMPORTED_MODULE_0__["EVENT_PREFIX"])[1];
      var event_desc = e.target.dataset.longan || e.target.innerText || '';
      var eventParams = {
        event_name: event_name,
        event_desc: event_desc,
        event_type: _constants_js__WEBPACK_IMPORTED_MODULE_0__["EVENT_TYPE_OPTIONS"]['click']
      };
      sendRequest(_extends({}, config, eventParams), 'event');
    } else {
      // 增加通用全局点击事件监听，可通过配置设置是否开启，默认 false
      var _config$use_global_au = config.use_global_auto_listen,
          use_global_auto_listen = _config$use_global_au === undefined ? false : _config$use_global_au;

      if (use_global_auto_listen) {
        // 表格元素不上报
        var filterElements = ['TABLE', 'TR', 'TD', 'TH', 'THEAD', 'TBODY'];
        var bubblePath = e.path.map(function (node) {
          return {
            tagName: node.nodeName,
            tagText: node.innerText || node.ariaLabel || node.alt || '未知文本',
            isClicked: !!node.onclick
          };
        }).slice(0, 7);
        var target = bubblePath.find(function (node) {
          return node.isClicked;
        });
        if (target && !filterElements.includes(target.tagName)) {
          var path = window.location.pathname.slice(1) || 'home';
          var _event_name = path + '-' + target.tagText;
          var _event_desc = window.location.hostname + '/' + path + ' \u2192 ' + target.tagText + '\u3010\u5143\u7D20:' + target.tagName + '\u3011';
          var _eventParams = {
            event_name: _event_name,
            event_desc: _event_desc,
            event_type: _constants_js__WEBPACK_IMPORTED_MODULE_0__["EVENT_TYPE_OPTIONS"]['click']
          };
          sendRequest(_extends({}, config, _eventParams), 'event');
        }
      }
    }
  });
};

// 上传埋点信息
var sendRequest = function sendRequest(params, type) {
  var configOnline = window.LONGAN_CONFIG.env.online;
  var configUat = window.LONGAN_CONFIG.env.uat;
  var longanUploadUrl = window.LONGAN_CONFIG.isSfApp ? 'http:' + _constants_js__WEBPACK_IMPORTED_MODULE_0__["UPLOAD_URL"] : _constants_js__WEBPACK_IMPORTED_MODULE_0__["UPLOAD_URL"];
  var host = window.location.host;
  var seeWidth = window.screen.width || 0;
  var seeHeight = window.screen.height || 0;
  var uniqueKey = Object(_utils__WEBPACK_IMPORTED_MODULE_1__["getUniqueKey"])();
  var alarmMsg = params.alarm_msg || '';
  var commonConfig = {
    // http_referer: window.location.origin + window.location.pathname,
    create_time: (new Date().getTime() / 1000).toFixed(0),
    page_title: document.title,
    env_type: configOnline.includes(host) ? _constants_js__WEBPACK_IMPORTED_MODULE_0__["ENV_TYPE"].online : configUat.includes(host) ? _constants_js__WEBPACK_IMPORTED_MODULE_0__["ENV_TYPE"].uat : _constants_js__WEBPACK_IMPORTED_MODULE_0__["ENV_TYPE"].develop,
    // user_agent: navigator.userAgent,
    device_type: Object(_utils__WEBPACK_IMPORTED_MODULE_1__["getDeviceType"])(),
    position_name: Object(_utils__WEBPACK_IMPORTED_MODULE_1__["getDevicePosition"])(),
    client_size: seeWidth + '*' + seeHeight,
    unique_key: uniqueKey
  };
  /// 这里处理hash路由，走http_referer，而不是走nginx日志的reqeust header rederer
  if (window.LONGAN_CONFIG.hash_route) {
    // 不能包含参数
    commonConfig.http_referer = window.location.origin + window.location.pathname + window.location.hash;
  }
  delete params.alarm_msg;
  params = Object(_utils__WEBPACK_IMPORTED_MODULE_1__["filterParams"])(_extends({}, params, commonConfig, window.LONGAN_CONFIG));
  if (window.LONGAN_CONFIG.filter_conditions && Array.isArray(window.LONGAN_CONFIG.filter_conditions) && window.LONGAN_CONFIG.filter_conditions.includes(type)) {
    return false;
  }
  if (params.cacheUpload && Number(params.cacheUpload) < _constants_js__WEBPACK_IMPORTED_MODULE_0__["MAX_CACHE_UPLOAD_NUMBER"] + 1 && Number(params.cacheUpload) > 0) {
    recordCacheLog(params, commonConfig.env_type);
  } else {
    var createLog = new _utils__WEBPACK_IMPORTED_MODULE_1__["CreateLog"](commonConfig.env_type, longanUploadUrl);
    var createLogParams = {};
    if (type === 'error' && params.error_tag) {
      createLogParams.warningTag = Object(_utils__WEBPACK_IMPORTED_MODULE_1__["createWarningTag"])(params);
      // let handleContent = getErrorType(params.error_content);      
      createLogParams.alarm_msg = 'errmsg[id=' + uniqueKey + ',' + (alarmMsg ? alarmMsg : '' + JSON.stringify(params.error_message)) + ']';
    }
    // const middleware = new MiddleWare();
    createLogParams = _extends({}, createLogParams, params);
    // if (type === 'error') {
    //   // 在用户配置报警tag（error_tag）时，上报alarm_msg字段，其他时候不上传。
    //   createLogParams.alarm_msg = `errmsg[id=${uniqueKey},fetchInfo=${params.error_content},other=${alarmMsg}]`
    // }
    delete createLogParams.error_tag;
    createLogParams = Object(_utils__WEBPACK_IMPORTED_MODULE_1__["parseParams"])(createLogParams);
    createLog.fetch(_constants_js__WEBPACK_IMPORTED_MODULE_0__["LOG_INTERFACE"][type] + '?' + createLogParams);
  }
};

// 记录，批量上传 “暂时不用了” 架构改用nginx收集日志，定时抓去日志入库，默认缓存上报。
var recordCacheLog = function recordCacheLog(params, env_type) {
  var oldCount = localStorage.getItem('longanCount');
  var oldContent = localStorage.getItem('longanContent') ? JSON.parse(localStorage.getItem('longanContent')) : [];
  if (oldCount === String(params.cacheUpload - 1)) {
    oldContent.push(params);
    var createLog = new _utils__WEBPACK_IMPORTED_MODULE_1__["CreateLog"](env_type, _constants_js__WEBPACK_IMPORTED_MODULE_0__["UPLOAD_URL"]);
    createLog.fetch('?cacheUpload=' + JSON.stringify(oldContent));
    // const image = new Image();
    // image.src = UPLOAD_URL + '?cacheUpload=' + JSON.stringify(oldContent);
    // 重置localstorage
    localStorage.setItem('longanCount', 0);
    localStorage.setItem('longanContent', JSON.stringify([]));
  } else {
    localStorage.setItem('longanCount', Number(oldCount || 0) + 1);
    localStorage.setItem('longanContent', JSON.stringify(oldContent.concat([params])));
  }
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPLOAD_URL", function() { return UPLOAD_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_PREFIX", function() { return EVENT_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_CACHE_UPLOAD_NUMBER", function() { return MAX_CACHE_UPLOAD_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_TYPE_OPTIONS", function() { return EVENT_TYPE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENV_TYPE", function() { return ENV_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_TYPE_OPTIONS", function() { return ERROR_TYPE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_LEVEL_MAP", function() { return ERROR_LEVEL_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_PARAMS_ARRAY", function() { return EVENT_PARAMS_ARRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_PARAMS_ARRAY", function() { return ERROR_PARAMS_ARRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WARNING_TAG", function() { return WARNING_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOG_INTERFACE", function() { return LOG_INTERFACE; });

// var UPLOAD_URL = '//longan.sf-express.com';
var UPLOAD_URL = '//longan.szfx.com';

var EVENT_PREFIX = 'longan-';

var MAX_CACHE_UPLOAD_NUMBER = 20;

var EVENT_TYPE_OPTIONS = {
  'click': 1,
  'selfDefine': 2
};

var ENV_TYPE = {
  online: 1,
  uat: 2,
  develop: 3
};

var ERROR_TYPE_OPTIONS = {
  SyntaxError: 1,
  ReferenceError: 2,
  RangeError: 3,
  TypeError: 4,
  URLError: 5,
  TSRunError: 6
};

var ERROR_LEVEL_MAP = {
  p0: 0,
  p1: 1,
  p2: 2
};

var EVENT_PARAMS_ARRAY = ['event_name', 'event_desc', 'event_type'];
var ERROR_PARAMS_ARRAY = ['error_message', 'error_script_url', 'error_line', 'error_column', 'error_content', 'error_type'];

var WARNING_TAG = 'WARN_THAT_THE_APPLICATION_HAS_ENCOUNTERED_AN_URGENT_PROBLEM';

var LOG_INTERFACE = {
  'basic': '/lg/basic',
  'event': '/lg/event',
  'error': '/lg/err',
  'performance': '/lg/pf'
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseParams", function() { return parseParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseObj2Str", function() { return parseObj2Str; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentTime", function() { return getCurrentTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUniqueKey", function() { return getUniqueKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentRoute", function() { return getCurrentRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDeviceType", function() { return getDeviceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDevicePosition", function() { return getDevicePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getErrorType", function() { return getErrorType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterParams", function() { return filterParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreateLog", function() { return CreateLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MiddleWare", function() { return MiddleWare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toUnderLine", function() { return toUnderLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createWarningTag", function() { return createWarningTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "whitherAddMeta", function() { return whitherAddMeta; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// 将参数转换为字符串
function parseParams(params) {
  if (Object.prototype.toString.call(params) !== '[object Object]') {
    return '';
  }
  return parseObj2Str(params);
}
function parseObj2Str(params) {
  return Object.keys(params).map(function (key) {
    if (Object.prototype.toString.call(params[key]) == '[object Object]' && key !== 'alarm_msg') {
      return encodeURIComponent(key) + '=' + encodeURIComponent(JSON.stringify(params[key]));
    } else if (key === 'alarm_msg') {
      return encodeURIComponent(key) + '=' + JSON.stringify(params[key]);
    } else {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }
  }).join('&') + '&';
}
// 获取当前时间的秒级时间戳
function getCurrentTime() {
  return (new Date().getTime() / 1000).toFixed(0);
}
function RndNum(n) {
  var rnd = "";
  for (var i = 0; i < n; i++) {
    rnd += Math.floor(Math.random() * 10);
  }
  return rnd;
}
// 唯一值，da做唯一键 毫秒时间戳加5位随机数
function getUniqueKey() {
  return new Date().getTime().toFixed(0) + RndNum(5);
}

// 获取当前域名和路径
function getCurrentRoute() {
  return window.location.origin + window.location.pathname;
}

// 获取设备类型，1: desktop, 2: mobile
function getDeviceType() {
  var isDesktop = true;
  var userAgentInfo = navigator.userAgent;
  var mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  for (var v = 0; v < mobileAgents.length; v++) {
    if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
      isDesktop = false;
      break;
    }
  }
  return isDesktop ? 1 : 2;
};

// 获取设备位置坐标
function getDevicePosition() {
  // 去掉地理服务，避免报弹窗
  var config = window.LONGAN_CONFIG;
  if (config.filter_fields && Array.isArray(config.filter_fields) && config.filter_fields.includes('position_name')) {
    return '';
  }
  if ("geolocation" in navigator) {
    var geo_options = {
      enableHighAccuracy: true,
      maximumAge: 0,
      timeout: 6000
    };
    navigator.geolocation.getCurrentPosition(function (pos) {
      var lng = pos.coords.longitude;
      var lat = pos.coords.latitude;
      return {
        longitude: lng,
        latitude: lat
      };
    }, function (err) {
      console.log(err.message);
    }, geo_options);
  } else {
    console.log("Browser didnt support geolocation");
  }
};

// 获取错误类型的枚举值 TSRunError: CompanyManage

function getErrorType(errorMessage) {
  // 1.SyntaxError（语法错误)、 2.ReferenceError（引用错误）、3.RangeError（范围错误）、4.TypeError（类型错误）、5.URLError（URL错误）6、TS 运行时类型错误
  var errorTypeArray = ['SyntaxError', 'ReferenceError', 'RangeError', 'TypeError', 'URLError', 'TSRunError'];
  var errorType = '';
  for (var v = 0; v < errorTypeArray.length; v++) {
    if (errorMessage.includes(errorTypeArray[v])) {
      errorType = errorTypeArray[v];
      break;
    }
  }
  return errorType;
}

// 过滤不必要上报字段
function filterParams(params) {
  var fileds = ['env', 'filter_fields', 'filter_error_msg'];
  var result = {};
  if (params.filter_fields && Array.isArray(params.filter_fields)) {
    Object.keys(params).forEach(function (key) {
      if (!fileds.includes(key) && !params.filter_fields.includes(key)) {
        result[key] = params[key];
      }
    });
    return result;
  } else {
    Object.keys(params).forEach(function (key) {
      if (!fileds.includes(key)) {
        result[key] = params[key];
      }
    });
    return result;
  }
}

//上传接口
//todo: 判断有陌生字段 取消上报
var CreateLog = function () {
  function CreateLog(env_type, baseUrl) {
    _classCallCheck(this, CreateLog);

    this.url = env_type == 3 ? 'test' : baseUrl;
    this.image = new Image();
  }

  _createClass(CreateLog, [{
    key: 'fetch',
    value: function fetch(params) {
      try {
        this.image.src = this.url + params;
      } catch (error) {
        console.warn("longan-sdk接口配置有误。", error);
      }
    }
  }, {
    key: 'onError',
    value: function onError(cb) {
      try {
        this.image.onError = cb;
      } catch (error) {
        console.warn("longan-sdk接口配置有误。", error);
      }
    }
  }, {
    key: 'onLoad',
    value: function onLoad(cb) {
      try {
        this.image.onLoad = cb;
      } catch (error) {
        console.warn("longan-sdk接口配置有误。", error);
      }
    }
  }]);

  return CreateLog;
}();

var MiddleWare = function () {
  function MiddleWare() {
    _classCallCheck(this, MiddleWare);

    this.cache = [];
  }

  _createClass(MiddleWare, [{
    key: 'use',
    value: function use(fn) {
      if (typeof fn !== 'function') {
        throw 'middleware must be a function';
      }
      this.cache.push(fn);
      return this;
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.middleWares && this.middleWares.length > 0) {
        var ware = this.middleWares.shift();
        ware.call(this, this.next.bind(this));
      }
    }
  }, {
    key: 'handleRequest',
    value: function handleRequest() {
      this.middleWares = this.cache.map(function (fn) {
        //复制
        return fn;
      });
      this.next();
    }
  }]);

  return MiddleWare;
}();

/**
 * 短横线专下划线
 *
 * @param {string} str
 * @returns
 */
var toUnderLine = function toUnderLine(str) {
  return str.replace(/-/g, '_');
};

/**
 * 生成报警信息
 * @param {{project_name:string;env_type:string;error_tag:string}} opt 
 * @returns 
 */
var createWarningTag = function createWarningTag(opt) {
  var formatName = toUnderLine(opt.project_name);
  var error_tag = toUnderLine(opt.error_tag);
  return _constants__WEBPACK_IMPORTED_MODULE_0__["WARNING_TAG"] + '_' + formatName + '_' + opt.env_type + '_' + error_tag;
};

// 判断head里是否有<meta name="referrer" content="unsafe-url">标签，没有则添加
var whitherAddMeta = function whitherAddMeta() {
  var meta = document.getElementsByTagName('meta');
  var tag = [].slice.call(meta).some(function (item) {
    return item.getAttribute('name') === 'referrer';
  });
  if (!tag) {
    var head = document.querySelector('head');
    var _meta = document.createElement('meta');
    _meta.name = 'referrer';
    _meta.content = 'unsafe-url';
    head.appendChild(_meta);
  }
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// 以下封装了history监听方法
var Dep = function () {
  function Dep(name) {
    _classCallCheck(this, Dep);

    this.id = new Date();
    this.subs = [];
  }

  _createClass(Dep, [{
    key: 'defined',
    value: function defined() {
      Dep.watch.add(this);
    }
  }, {
    key: 'notify',
    value: function notify() {
      this.subs.forEach(function (e, i) {
        if (typeof e.update === 'function') {
          try {
            e.update.apply(e);
          } catch (err) {
            console.warn(err);
          }
        }
      });
    }
  }]);

  return Dep;
}();

Dep.watch = null;

var Watch = function () {
  function Watch(name, fn) {
    _classCallCheck(this, Watch);

    this.name = name;
    this.id = new Date();
    this.callBack = fn;
  }

  _createClass(Watch, [{
    key: 'add',
    value: function add(dep) {
      dep.subs.push(this);
    }
  }, {
    key: 'update',
    value: function update() {
      var cb = this.callBack;
      cb(this.name);
    }
  }]);

  return Watch;
}();

var addHistoryMethod = function () {
  var historyDep = new Dep();
  var historyMethods = ['pushState', 'replaceState', 'push'];
  return function (name) {
    if (name === 'historychange') {
      return function (name, fn) {
        var event = new Watch(name, fn);
        Dep.watch = event;
        historyDep.defined();
        Dep.watch = null;
      };
    } else if (historyMethods.includes(name)) {
      var method = history[name];
      return function () {
        method.apply(history, arguments);
        historyDep.notify();
      };
    }
  };
}();

window.addHistoryListener = addHistoryMethod('historychange');
history.pushState = addHistoryMethod('pushState');
history.replaceState = addHistoryMethod('replaceState');
history.push = addHistoryMethod('push');

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dispatchEvent", function() { return dispatchEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dispatchError", function() { return dispatchError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dispatchWithoutRegister", function() { return dispatchWithoutRegister; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _register__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var dispatchEvent = function dispatchEvent(params) {
  var event_type = params.event_type,
      event_name = params.event_name,
      event_desc = params.event_desc;

  if (!validateRequireParams(params, _constants__WEBPACK_IMPORTED_MODULE_0__["EVENT_PARAMS_ARRAY"])) {
    return false;
  }
  var eventTypeOptions = Object.keys(_constants__WEBPACK_IMPORTED_MODULE_0__["EVENT_TYPE_OPTIONS"]);
  if (!eventTypeOptions.includes(event_type)) {
    console.error('事件类型错误');
    return false;
  }
  var config = window.LONGAN_CONFIG;
  var payload = _extends({}, config, {
    event_name: event_name,
    event_desc: event_desc,
    event_type: _constants__WEBPACK_IMPORTED_MODULE_0__["EVENT_TYPE_OPTIONS"][event_type]
  });
  Object(_register__WEBPACK_IMPORTED_MODULE_2__["sendRequest"])(payload, 'event');
};

var dispatchError = function dispatchError(params) {
  var _params$error_message = params.error_message,
      error_message = _params$error_message === undefined ? "-1" : _params$error_message,
      _params$error_script_ = params.error_script_url,
      error_script_url = _params$error_script_ === undefined ? '-1' : _params$error_script_,
      _params$error_line = params.error_line,
      error_line = _params$error_line === undefined ? '-1' : _params$error_line,
      _params$error_column = params.error_column,
      error_column = _params$error_column === undefined ? '-1' : _params$error_column,
      _params$error_content = params.error_content,
      error_content = _params$error_content === undefined ? '-1' : _params$error_content,
      _params$error_level = params.error_level,
      error_level = _params$error_level === undefined ? '2' : _params$error_level,
      _params$error_tag = params.error_tag,
      error_tag = _params$error_tag === undefined ? '' : _params$error_tag,
      _params$alarm_msg = params.alarm_msg,
      alarm_msg = _params$alarm_msg === undefined ? '' : _params$alarm_msg;

  var checkResult = Object.keys(params).find(function (field) {
    return typeof params[field] != 'string';
  });
  if (checkResult) {
    console.error('\u4E0A\u62A5\u9519\u8BEF\u7C7B\u578B\u5B57\u6BB5:' + checkResult + ',\u7C7B\u578B\u9700\u4E3A\u5B57\u7B26\u4E32\u7C7B\u578B');
    return false;
  }

  var filter_error_msg = window.LONGAN_CONFIG.filter_error_msg;

  if (filter_error_msg && Array.isArray(filter_error_msg)) {
    var filterResult = filter_error_msg.filter(function (item) {
      return error_message.includes(item);
    });
    if (filterResult && filterResult.length) {
      return false;
    }
  }

  var config = window.LONGAN_CONFIG;
  console.info(error_message.toString(), Object(_utils__WEBPACK_IMPORTED_MODULE_1__["getErrorType"])(error_message.toString()), _constants__WEBPACK_IMPORTED_MODULE_0__["ERROR_TYPE_OPTIONS"]);
  var payload = _extends({
    error_content: error_content,
    error_message: error_message,
    error_script_url: error_script_url,
    error_line: error_line,
    error_column: error_column,
    error_level: error_level,
    error_type: _constants__WEBPACK_IMPORTED_MODULE_0__["ERROR_TYPE_OPTIONS"][Object(_utils__WEBPACK_IMPORTED_MODULE_1__["getErrorType"])(error_message.toString())] || 1,
    error_tag: error_tag,
    alarm_msg: alarm_msg
  }, config);

  var errorKey = '' + error_message.toString();
  if (!window._LONGAN_CACHE_ERROR_[errorKey] || new Date().valueOf() - window._LONGAN_CACHE_ERROR_[errorKey] > 600000) {
    Object(_register__WEBPACK_IMPORTED_MODULE_2__["sendRequest"])(payload, 'error');
    window._LONGAN_CACHE_ERROR_[errorKey] = new Date().valueOf();
  }
  // sendRequest({ payload }, 'error');
};

var dispatchWithoutRegister = function dispatchWithoutRegister(params) {
  var type = params.type,
      data = params.data;

  var createLog = new _utils__WEBPACK_IMPORTED_MODULE_1__["CreateLog"]();
  var seeWidth = window.screen.width || 0;
  var seeHeight = window.screen.height || 0;
  var commonConfig = {
    create_time: (new Date().getTime() / 1000).toFixed(0),
    page_title: document.title,
    env_type: '1',
    device_type: Object(_utils__WEBPACK_IMPORTED_MODULE_1__["getDeviceType"])(),
    client_size: seeWidth + '*' + seeHeight,
    unique_key: Object(_utils__WEBPACK_IMPORTED_MODULE_1__["getUniqueKey"])()
  };
  var createLogParams = _extends({}, commonConfig, data);
  createLog.url = _constants__WEBPACK_IMPORTED_MODULE_0__["UPLOAD_URL"];
  switch (type) {
    case 'error':
      var _createLogParams = createLogParams,
          _createLogParams$erro = _createLogParams.error_message,
          error_message = _createLogParams$erro === undefined ? "-1" : _createLogParams$erro,
          _createLogParams$erro2 = _createLogParams.error_script_url,
          error_script_url = _createLogParams$erro2 === undefined ? '-1' : _createLogParams$erro2,
          _createLogParams$erro3 = _createLogParams.error_line,
          error_line = _createLogParams$erro3 === undefined ? '-1' : _createLogParams$erro3,
          _createLogParams$erro4 = _createLogParams.error_column,
          error_column = _createLogParams$erro4 === undefined ? '-1' : _createLogParams$erro4,
          _createLogParams$erro5 = _createLogParams.error_content,
          error_content = _createLogParams$erro5 === undefined ? '-1' : _createLogParams$erro5,
          _createLogParams$erro6 = _createLogParams.error_type,
          error_type = _createLogParams$erro6 === undefined ? '1' : _createLogParams$erro6,
          _createLogParams$erro7 = _createLogParams.error_level,
          error_level = _createLogParams$erro7 === undefined ? '2' : _createLogParams$erro7,
          _createLogParams$erro8 = _createLogParams.error_tag,
          error_tag = _createLogParams$erro8 === undefined ? '' : _createLogParams$erro8;

      var checkResult = Object.keys(data).find(function (field) {
        return typeof data[field] != 'string';
      });
      if (checkResult) {
        console.error('\u4E0A\u62A5\u9519\u8BEF\u7C7B\u578B\u5B57\u6BB5:' + checkResult + ',\u7C7B\u578B\u9700\u4E3A\u5B57\u7B26\u4E32\u7C7B\u578B');
        return false;
      }
      if (error_tag) {
        createLogParams.warningTag = Object(_utils__WEBPACK_IMPORTED_MODULE_1__["createWarningTag"])(createLogParams);
      }
      delete createLogParams.error_tag;
      createLogParams = Object(_utils__WEBPACK_IMPORTED_MODULE_1__["parseParams"])(_extends({
        error_content: error_content,
        error_message: error_message,
        error_script_url: error_script_url,
        error_line: error_line,
        error_column: error_column,
        error_level: error_level,
        error_type: error_type
      }, createLogParams));
      createLog.fetch(_constants__WEBPACK_IMPORTED_MODULE_0__["LOG_INTERFACE"][type] + '?' + createLogParams);
      break;
    case 'event':
      createLogParams = Object(_utils__WEBPACK_IMPORTED_MODULE_1__["parseParams"])(createLogParams);
      createLog.fetch(_constants__WEBPACK_IMPORTED_MODULE_0__["LOG_INTERFACE"][type] + '?' + createLogParams);
      break;
    default:
      console.warn('longan warning: 参数type不合法');
      break;
  }
};

var validateRequireParams = function validateRequireParams(config, fields) {
  if (Array.isArray(fields)) {
    var result = fields.find(function (field) {
      return !config[field];
    });
    return !result;
  } else {
    return false;
  }
};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// 更新配置信息
/* harmony default export */ __webpack_exports__["default"] = (function (config) {
  if (Object.prototype.toString.call(config) !== '[object Object]') {
    console.log('配置信息格式应为对象');
    return false;
  }
  window.LONGAN_CONFIG = _extends({}, window.LONGAN_CONFIG, config);
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var jsonschema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var jsonschema__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsonschema__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _dispatch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/*
 * @Author: xm
 * @Date: 2021-08-25 14:33:01
 * @LastEditTime: 2021-08-27 15:29:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /longan-sdk/src/validate.js
 */



var v = new jsonschema__WEBPACK_IMPORTED_MODULE_0__["Validator"]();

/**
 * 
 * @param {*} schemaNameSpace  生成的schemaJson 中的 $id 值
 * @param {*} schemaJson  生成的schemaJson
 */
function addSchema(_ref) {
  var _ref$schemaNameSpace = _ref.schemaNameSpace,
      schemaNameSpace = _ref$schemaNameSpace === undefined ? '' : _ref$schemaNameSpace,
      schemaJson = _ref.schemaJson;

  if (!schemaNameSpace) schemaNameSpace = schemaJson.$id;
  v.addSchema(schemaJson, '/' + schemaNameSpace);
  /**
   * @param {*} instance 要校验的数据
   * @param {*} targetSchema 目标TSJSON
   */
  function validate(_ref2) {
    var instance = _ref2.instance,
        targetSchema = _ref2.targetSchema,
        url = _ref2.url;

    if (typeof schemaNameSpace === 'string' && typeof targetSchema === 'string') {
      try {
        // const v = new Validator();
        // v.addSchema(schemaJson, `/${schemaNameSpace}`);
        var res = v.validate(instance, {
          $ref: schemaNameSpace + '#/definitions/' + targetSchema
        });
        if (!res.valid) {
          var err = res.errors.map(function (item) {
            return item.stack;
          });
          Object(_dispatch__WEBPACK_IMPORTED_MODULE_1__["dispatchError"])({
            error_message: 'TSRunError: ' + schemaNameSpace + ' [' + url + ']',
            error_content: err.join('*'),
            error_level: '1',
            error_tag: 'error_TS_RUN_TIME'

          });
        }
      } catch (e) {
        console.log(e, 'validate fail xm');
      }
    } else {
      throw new Error('validate:参数错误');
    }
  }
  return validate;
}

/* harmony default export */ __webpack_exports__["default"] = (addSchema);

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("jsonschema");

/***/ })
/******/ ]);